import { lazy, Route } from '@tanstack/router'

import type { ReferralSearch } from '.'
import { referralRoute } from '.'

const InvitationCodes = lazy(
  () => import('../../../pages/profile/referral/invitation-codes'),
)

export const invitationCodesRoute = new Route({
  getParentRoute: () => referralRoute,
  path: 'codes',
  component: InvitationCodes,
  validateSearch: (search: Record<string, unknown>): ReferralSearch => {
    return search
  },
})
